<template>
  <vs-popup
    class="show-user-tasting-forms-list-popup"
    id="popup"
    title="Show User Tasting Forms List"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
  <div>
    <vs-table
            id="user-tasting-forms-list-table"
            :data="userTastingFormsList"
            :sst="true"
          >
            <template slot="thead">
              <vs-th>CODE</vs-th>
              <vs-th>BATCH CODE</vs-th>
              <!-- <vs-th>TYPE</vs-th> -->
              <vs-th>STATUS</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                v-for="(tr, indextr) in data"
                :key="indextr"
                :data="tr"
                style="cursor: pointer"
              >
              <vs-td>{{ tr.code }}</vs-td>
                <vs-td>{{ getBatchCode(tr) }}</vs-td>
                <!-- <vs-td>{{ getBatchType(tr.type) }}</vs-td> -->
                <vs-td>{{ tr.status }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
  </div>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");

export default {
  name: "ShowUserTastingFormsList",
  data() {
    return {
      open: false,
      staffId: null,
      userTastingFormsList: [],
      group_id: null,
    };
  },
  methods: {
    async openPopup(staff_id, group_id) {
      this.open = true;
      this.staffId = staff_id;
      this.group_id = group_id;
      await this.getUserTastingFormsList();
    },
    async getUserTastingFormsList() {
        const response = await TriangleTestsRepository.getListOfQualityControlTestings(`filter[done_by_id]=${this.staffId}&filter[group_id]=${this.group_id}`)
        this.userTastingFormsList = response.data.data
    },
    getBatchType(typeString) {
      var typeMap = {
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\WorkOrder":
          "Work Order",
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\RawMaterialStockInventory":
          "Raw Material Inventory",
      };

      return typeMap[typeString];
    },

    getBatchCode(dataSet) {
      if (this.getBatchType(dataSet.batch_type) === "Work Order") {
        return dataSet.batch.work_order_code;
      } else {
        return dataSet.batch.code;
      }
    },
  },
};
</script>
<style scoped>
.show-user-tasting-forms-list-popup {
  min-width: 80% !important;
}
</style>
